/*
 *
 * ChatbotWrapper
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 12-May-2025
 */

import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import ChatbotWrapper from './ChatbotWrapper'

const mapDispatchToProps = dispatch => ({

})

const mapStateToProps = () => ({

})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ChatbotWrapper)
